import React from 'react'

import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { setLayerFilter } from 'drawer/tabs/layers/actions'
import PoziMap from 'map/map'

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: '250px',
    'text-align': 'left',
    'margin-left': 0,
    'padding-left': 0,
    'border-left': 0
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  cssLabel: {
    'font-weight': 'normal',
    '&$cssFocused': {
      color: '#424242'
    }
  },
  cssFocused: {}
})

class LayerFilterValueSelect extends React.Component {
  component = this

  constructor(props) {
    super(props)

    const { layer } = props
    if (layer && layer.propsFilter && layer.propsFilter.value) {
      this.state = {
        selectedValue: layer.propsFilter.value
      }
    } else {
      this.state = {
        selectedValue: ''
      }
    }
  }

  componentDidMount() {
    const { geojson } = this.props
    this.setState({ geojson })
  }

  handleChange = (event) => {
    const { titleid, layer, dispatchSetLayerFilter, selectedProp } = this.props

    this.setState({ [event.target.name]: event.target.value }) // this. refers to the MenuItem component.

    let newPropsFilter = null

    if (event.target.value !== '(All)') {
      newPropsFilter = {
        prop: selectedProp,
        value: event.target.value
      }
    }

    console.debug('LayerFilterValueSelect - handleChange filter', layer)

    dispatchSetLayerFilter(titleid, newPropsFilter)

    PoziMap().showFeaturesInLayer(layer, newPropsFilter?.prop || '', newPropsFilter?.value || '')
  }

  render() {
    const { classes, titleid, selectedProp, geojson, layer } = this.props
    if (!layer || !geojson || !geojson.features || geojson.features.length === 0 || selectedProp === '' || titleid === '' || selectedProp === '(None)') {
      return null
    }

    if (!layer || (!layer.visible && !layer.selected)) {
      return null
    }

    // console.debug('LayerFilterValueSelect - render', titleid, selectedProp)

    const noneKey = 'layers-filter-select-options-none-' + titleid
    const menuItemArr = []
    menuItemArr.push(
      <MenuItem key={noneKey} value='(All)'>
        <em>(All)</em>
      </MenuItem>
    )

    const tempProps = []

    for (const feature of geojson.features) {
      tempProps[feature.properties[selectedProp]] = true
    }

    const uniqueValues = new Set()
    for (const feature of geojson.features) {
      const value = feature.properties[selectedProp]
      if (value !== undefined && value !== null) {
        uniqueValues.add(value)
      }
    }
    let values = Array.from(uniqueValues)

    if (values && values.length > 0 && values[0] !== 'undefined') {
      // Sort to avoid sorting numbers as strings
      values = values.sort((a, b) => {
        const numA = Number(a)
        const numB = Number(b)
        return !isNaN(numA) && !isNaN(numB) ? numA - numB : a.localeCompare(b)
      })

      for (const value of values) {
        const labelDisplay = value
        menuItemArr.push(
          <MenuItem key={value} value={value}>
            <em>{labelDisplay}</em>
          </MenuItem>
        )
      }
    }

    const id = 'layers-filter-select-prop-value-' + titleid

    return (
      <div className='pozi-layer-filter-value-select'>
        <form className={classes.root} autoComplete='off'>
          <FormControl className={classes.formControl}>
            <InputLabel
              shrink
              classes={{
                root: classes.cssLabel,
                focused: classes.cssFocused
              }}
              htmlFor={id}
            >
              Value...
            </InputLabel>
            <Select
              value={this.state.selectedValue}
              onChange={this.handleChange}
              displayEmpty
              inputProps={{
                name: 'selectedValue',
                id
              }}
            >
              {menuItemArr}
            </Select>
          </FormControl>
        </form>
      </div>
    )
  }
}

LayerFilterValueSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  selectedProp: PropTypes.string.isRequired,
  geojson: PropTypes.object.isRequired,
  titleid: PropTypes.string.isRequired,
  dispatchSetLayerFilter: PropTypes.func.isRequired,
  layer: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps) {
  return {
    layer: state.layers[ownProps.titleid]
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchSetLayerFilter: (titleid, propsFilter) => {
      dispatch(setLayerFilter(titleid, propsFilter))
    }
  }
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(LayerFilterValueSelect))
